module.exports = __webpack_public_path__ + "img/jwt.3ebfc96f.svg";